import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { alpha, Link, styled, Typography, Button } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { useTranslation } from 'react-i18next';
import { BUSINESS_OPPORTUNITY_URL, DESKTOP_BREAKPOINT } from '../../constants';
import { useNavigationContext } from '../../contexts/NavigationContext';
import { LocalizationKeys } from '../../models/localizationKeys';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Root = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    textAlign: 'center'
  };
});
var RegisterLabel = styled('div')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: theme.typography.pxToRem(32),
    marginTop: theme.spacing(4),
    textAlign: 'center'
  };
});
var RegisterLabelLink = styled(Link)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: theme.typography.pxToRem(32),
    marginTop: theme.spacing(4),
    textAlign: 'center',
    textDecoration: 'none',
    '&:hover, &:focus, &:active': {
      color: theme.palette.text.disabled,
      WebkitTapHighlightColor: 'transparent'
    }
  };
});
var RegisterTilesList = styled('div')(function (_ref4) {
  var theme = _ref4.theme;
  return {
    margin: theme.spacing(3, -4, 2)
  };
});
var RegisterTile = styled(Link)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    background: theme.palette.grey[100],
    display: 'block',
    padding: theme.spacing(2),
    textDecoration: 'none',
    '&:hover, &:focus, &:active': {
      background: alpha(theme.palette.common.black, 0.05),
      color: theme.palette.warning.contrastText,
      WebkitTapHighlightColor: 'transparent'
    },
    '&:not(:first-of-type)': {
      marginTop: theme.spacing(1)
    }
  };
});
var RegisterTileDescription = styled(Typography)(function (_ref6) {
  var theme = _ref6.theme;
  return _defineProperty({
    lineHeight: theme.typography.pxToRem(19),
    paddingBottom: theme.spacing(1),
    textAlign: 'center'
  }, theme.breakpoints.up(DESKTOP_BREAKPOINT), {
    lineHeight: theme.typography.pxToRem(17)
  });
});
var RegisterTileTitle = styled('div')(function (_ref8) {
  var theme = _ref8.theme;
  return {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: theme.typography.pxToRem(19),
    textAlign: 'center'
  };
});
var RegisterIdkyLink = styled(Link)(function (_ref9) {
  var theme = _ref9.theme;
  return {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
    margin: theme.spacing(0, 'auto'),
    '&:hover, &:focus, &:active': {
      color: theme.palette.text.disabled,
      WebkitTapHighlightColor: 'transparent'
    }
  };
});
var RegisterHeaderLabel = styled(Typography)(function (_ref10) {
  var theme = _ref10.theme;
  return {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(4),
    textAlign: 'center'
  };
});
var JoinUsButton = styled(Button)(function (_ref11) {
  var theme = _ref11.theme;
  return {
    userSelect: 'none'
  };
});
export var Register = function Register(_ref12) {
  var loginConfiguration = _ref12.loginConfiguration;

  var _useNavigationContext = useNavigationContext(),
      joinTiles = _useNavigationContext.joinTiles,
      iDontKnowYetLink = _useNavigationContext.iDontKnowYetLink;

  var _useTranslation = useTranslation(),
      _useTranslation2 = _slicedToArray(_useTranslation, 1),
      translate = _useTranslation2[0];

  var _useTestId = useTestId(),
      getTestId = _useTestId.getTestId;

  if (loginConfiguration.IsSingleRegistrationLinkEnabled) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(RegisterHeaderLabel, {
        variant: "h6",
        "data-testid": getTestId('register-title'),
        children: translate(LocalizationKeys.register.id)
      }), /*#__PURE__*/_jsx(JoinUsButton, {
        variant: "contained",
        color: "secondary",
        href: loginConfiguration.RegistrationLink,
        children: translate(LocalizationKeys.joinOriflame.id)
      })]
    });
  }

  if (joinTiles.length === 0) {
    return /*#__PURE__*/_jsx(RegisterLabelLink, {
      href: BUSINESS_OPPORTUNITY_URL,
      children: translate(LocalizationKeys.register.id)
    });
  }

  return /*#__PURE__*/_jsxs(Root, {
    "data-testid": getTestId('register-wrapper'),
    children: [/*#__PURE__*/_jsx(RegisterLabel, {
      "data-testid": getTestId('register-title'),
      children: translate(LocalizationKeys.register.id)
    }), /*#__PURE__*/_jsx(RegisterTilesList, {
      "data-testid": getTestId('register-list'),
      children: joinTiles.map(function (_ref13) {
        var url = _ref13.url,
            title = _ref13.title,
            description = _ref13.description;
        return /*#__PURE__*/_jsxs(RegisterTile, {
          href: url,
          "data-testid": getTestId("register-link-".concat(url === null || url === void 0 ? void 0 : url.slice(1))),
          children: [/*#__PURE__*/_jsx(RegisterTileDescription, {
            variant: "body1",
            children: description
          }), /*#__PURE__*/_jsx(RegisterTileTitle, {
            children: title
          })]
        }, url);
      })
    }), (iDontKnowYetLink === null || iDontKnowYetLink === void 0 ? void 0 : iDontKnowYetLink.url) && /*#__PURE__*/_jsx(RegisterIdkyLink, {
      href: iDontKnowYetLink.url,
      "data-testid": getTestId('register-hesitant'),
      children: iDontKnowYetLink.title
    })]
  });
};